import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  scrollLinksToTop (event) {
    const link = event.target.closest('a')

    if (link) {
      window.scrollTo({ top: 0 })
    }
  }

  scrollToTop () {
    window.scrollTo({ top: 0 })
  }
}
